'use strict';

/**
 * initialize slick
 * @function initSlick
 */
function initSlick() {
    const isMobile = $(window).width() < 1280;
    const $slickContainer = $('.store-info-wrapper');
    // Initialize Slick for mobile
    if (isMobile) {
        if (!$slickContainer.hasClass('slick-initialized')) {
            $slickContainer.slick({
                dots: true,
                arrows: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplaySpeed: 3000,
                autoplay: true
            });
        } else {
            // Resume autoplay in case it got paused after interaction/scroll
            $slickContainer.slick('slickPlay');
        }
    } else if ($slickContainer.hasClass('slick-initialized')) {
        $slickContainer.slick('unslick');
    }
}

$(document).ready(function () {
    // Initialize Slick on page load
    initSlick();

    // Recheck on window resize
    $(window).resize(function () {
        initSlick();
    });
});
